var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-img", {
        staticClass: "bkg_img",
        attrs: {
          fluid: "",
          src: require("@/assets/images/pages/graphic-1.png")
        }
      }),
      _c(
        "div",
        { attrs: { id: "newsletter-public" } },
        [
          _c(
            "b-card",
            {
              staticClass: "h-full",
              attrs: { "header-bg-variant": "primary", "no-body": "" },
              scopedSlots: _vm._u([
                {
                  key: "header",
                  fn: function() {
                    return [
                      _c(
                        "span",
                        { staticClass: "text-white text-lg font-bold" },
                        [_vm._v(_vm._s(_vm.newsletter.title))]
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "footer",
                  fn: function() {
                    return [
                      _c("page-footer", { attrs: { showLoginLink: false } })
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _vm.hasNewsletterNotFount
                ? _c(
                    "b-container",
                    { staticClass: "p-4 bg-primary", attrs: { fluid: "" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-img", {
                                attrs: {
                                  center: "",
                                  thumbnail: "",
                                  fluid: "",
                                  src: require("@/assets/images/pages/404-2.png"),
                                  alt: "Página 404"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.hasNewsletter
                ? _c("div", { staticClass: "pt-1 p-1" }, [
                    _c("div", { staticClass: "flex flex-col gap-1" }, [
                      _c(
                        "div",
                        { staticClass: "_row" },
                        [
                          _c("complex-editor-view", {
                            attrs: { editor_data: _vm.newsletter.content },
                            on: {
                              "update:editor_data": function($event) {
                                return _vm.$set(
                                  _vm.newsletter,
                                  "content",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "w-full align-middle gap-2 justify-end"
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "pl-1 text-primary align-middle" },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "EyeIcon" }
                              }),
                              _c("span", { staticClass: "align-middle" }, [
                                _vm._v(
                                  _vm._s(_vm.countView) +
                                    " " +
                                    _vm._s(_vm.$t("newsletter.view"))
                                )
                              ])
                            ],
                            1
                          ),
                          _c(
                            "span",
                            { staticClass: "pl-1 text-primary align-middle" },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "MessageCircleIcon" }
                              }),
                              _c("span", { staticClass: "align-middle" }, [
                                _vm._v(
                                  _vm._s(_vm.countComments) +
                                    " " +
                                    _vm._s(_vm.$t("newsletter.comment"))
                                )
                              ])
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "w-full align-middle gap-2 pb-2 justify-start"
                        },
                        [
                          _vm.alownLike
                            ? _c(
                                "b-button",
                                {
                                  staticClass: "btn-icon",
                                  attrs: { variant: "flat-success" },
                                  on: { click: _vm.likeContent }
                                },
                                [
                                  _c("feather-icon", {
                                    staticClass: "mr-50",
                                    attrs: { icon: "ThumbsUpIcon" }
                                  }),
                                  _c("span", { staticClass: "align-middle" }, [
                                    _vm._v(
                                      _vm._s(_vm.countLike) +
                                        " " +
                                        _vm._s(_vm.$t("action.like"))
                                    )
                                  ])
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.alownSignReading
                            ? _c(
                                "b-button",
                                {
                                  staticClass: "btn-icon",
                                  attrs: { variant: "flat-warning" },
                                  on: { click: _vm.signReading }
                                },
                                [
                                  _c("feather-icon", {
                                    staticClass: "mr-50",
                                    attrs: { icon: "BookOpenIcon" }
                                  }),
                                  _c("span", { staticClass: "align-middle" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("action.sign_reading"))
                                    )
                                  ])
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e(),
              _vm.hasNewsletter && _vm.alownComments
                ? _c(
                    "b-row",
                    { staticClass: "m-0 mb-2" },
                    [
                      _c(
                        "b-col",
                        { attrs: { lg: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "newsletter.comments.add_comment"
                                ),
                                "label-for": "comment"
                              }
                            },
                            [
                              _c("b-form-textarea", {
                                attrs: {
                                  id: "comment",
                                  state: _vm.stateComment,
                                  placeholder: _vm.$t("form_min_caracter_", [
                                    10
                                  ]),
                                  rows: "4"
                                },
                                model: {
                                  value: _vm.comment.content,
                                  callback: function($$v) {
                                    _vm.$set(_vm.comment, "content", $$v)
                                  },
                                  expression: "comment.content"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "w-full flex gap-2 justify-end pb-1"
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: "primary",
                                    disabled: !_vm.stateComment
                                  },
                                  on: { click: _vm.saveComment }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("action.send_comment")) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c("comments-include", {
                attrs: {
                  newsletterId: _vm.newsletter.id,
                  comments: _vm.newsletter.comments,
                  showComments: _vm.hasNewsletter && _vm.alownComments
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            title: _vm.$t("newsletter.sign_reading"),
            "hide-footer": true,
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          },
          model: {
            value: _vm.showModalSignReading,
            callback: function($$v) {
              _vm.showModalSignReading = $$v
            },
            expression: "showModalSignReading"
          }
        },
        [
          _c("div", { staticClass: "vx-row" }, [
            _c(
              "div",
              { staticClass: "vx-col w-full" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      id: "signature_name",
                      label: _vm.$t("newsletter.signature_name"),
                      "label-for": "signature_name"
                    }
                  },
                  [
                    _c("b-form-input", {
                      staticClass: "required",
                      attrs: {
                        id: "signature_name",
                        name: "signature_name",
                        state: _vm.nameState
                      },
                      model: {
                        value: _vm.signature.name,
                        callback: function($$v) {
                          _vm.$set(_vm.signature, "name", $$v)
                        },
                        expression: "signature.name"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "vx-row" }, [
            _c(
              "div",
              { staticClass: "vx-col w-full" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      id: "signature_email",
                      label: _vm.$t("newsletter.signature_email"),
                      "label-for": "signature_email"
                    }
                  },
                  [
                    _c("b-form-input", {
                      staticClass: "required",
                      attrs: {
                        id: "signature_email",
                        name: "signature_email",
                        state: _vm.emailState
                      },
                      model: {
                        value: _vm.signature.email,
                        callback: function($$v) {
                          _vm.$set(_vm.signature, "email", $$v)
                        },
                        expression: "signature.email"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm.showLegalEntityList
            ? _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: _vm.$t("legal_entities_unit"),
                          "label-for": "legal_entities_unit"
                        }
                      },
                      [
                        _c(
                          "v-select",
                          {
                            staticClass: "required-select",
                            attrs: {
                              options: _vm.legalEntityList,
                              label: "company_name",
                              "append-to-body": false,
                              "select-on-tab": true,
                              clearable: false
                            },
                            model: {
                              value: _vm.selectedLegalEntity,
                              callback: function($$v) {
                                _vm.selectedLegalEntity = $$v
                              },
                              expression: "selectedLegalEntity"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                attrs: { slot: "no-options" },
                                slot: "no-options"
                              },
                              [_vm._v(_vm._s(_vm.$t("msg_none")))]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "w-full flex gap-2 justify-end pt-4" },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    variant: "primary",
                    disabled: !_vm.enableSaveSignature
                  },
                  on: { click: _vm.saveSignature }
                },
                [_vm._v(" " + _vm._s(_vm.$t("action.signature")) + " ")]
              ),
              _c(
                "b-button",
                {
                  attrs: { variant: "outline-secondary" },
                  on: { click: _vm.closeModalSignReading }
                },
                [_vm._v(" " + _vm._s(_vm.$t("action.close")) + " ")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }